import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { InvoiceCustomerSchema, InvoiceSchema } from '../base/index.js';
export const CreateInvoiceApiSchema = {
    body: InvoiceSchema.pick({ total: true }).extend({
        customer: InvoiceCustomerSchema.omit({ id: true, name: true }),
    }),
    params: z.object({
        entityId: CornSchema,
    }),
    headers: z.object({ requestActor: z.string() }),
    response: InvoiceSchema.optional(),
};
export const CreateInvoicePathSchema = CreateInvoiceApiSchema.params;
export const CreateInvoiceHeadersSchema = CreateInvoiceApiSchema.headers;
export const CreateInvoiceBodySchema = CreateInvoiceApiSchema.body;
export const CreateInvoiceRequestSchema = CreateInvoiceBodySchema.merge(CreateInvoiceHeadersSchema).merge(CreateInvoicePathSchema);
export const CreateInvoiceResponseSchema = CreateInvoiceApiSchema.response;
